import { render, staticRenderFns } from "./m_info.vue?vue&type=template&id=404400ed&scoped=true&"
import script from "./m_info.vue?vue&type=script&lang=js&"
export * from "./m_info.vue?vue&type=script&lang=js&"
import style0 from "./m_info.vue?vue&type=style&index=0&id=404400ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404400ed",
  null
  
)

export default component.exports